
import {CommonProps} from "../CommonProps";
import {Children, LocalizedString} from "../Children";
import {InlineLinkDisabledStyled, InlineLinkStyled} from "./bodyStyles";
import {fromKeyCodesFilter, keyCodes} from "../../../constants/keyCodes";

type Props = CommonProps & {
    children: LocalizedString;
} & (
    | {
    onClick?: never;
    href: string;
}
    | {
    onClick: () => unknown;
    href?: never;
}
    ) & {
    disabled?: boolean;
    icon?: (props: { size: "default" }) => Children;
} & { ariaLabel?: LocalizedString; };

/**
 * @internal
 */
export function InlineLink(props: Props) {
    const disabled = props.disabled;

    if (disabled) {
        return (
            <InlineLinkDisabledStyled id={props.id}>
                {props.icon ? props.icon({ size: "default" }) : null}
                {props.children}
            </InlineLinkDisabledStyled>
        );
    } else {
        return (
            <InlineLinkStyled
                tabIndex={0}
                role={"button"}
                aria-label={props.ariaLabel}
                id={props.id}
                target="_blank"
                rel="noopener noreferrer"
                href={props.href || "#"}
                onKeyDown={fromKeyCodesFilter([keyCodes.Space, keyCodes.Enter], (e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onClick && props.onClick();
                })}
                onClick={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onClick && props.onClick();
                }}
            >
                {props.icon ? props.icon({ size: "default" }) : null}
                {props.children}
            </InlineLinkStyled>
        );
    }
}